var p2s = /,?([a-z]),?/gi;

module.exports = function parsePathArray(path) {
  return path.join(',').replace(p2s, '$1');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/path/parse-path-array.js
// module id = 153
// module chunks = 0 1 2